import {Dimensions, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  ctaBox: {
    borderTopWidth: 1,
    position: 'absolute',
    bottom: 0,
    width: Dimensions.get('window').width,
    alignSelf: 'center',
    paddingBottom: 10,
    padding: 20,
  },
  cta: {
    borderRadius: 100,
  },
  printerIssues: {
    marginTop: 10,
  },
  printerIssuesText: {
    textDecorationLine: 'underline',
  },
});
